export const maskCep = (value: string) => {
  const cleaned = value.replace(/\D/g, "").slice(0, 8);
  return cleaned.length <= 5
    ? cleaned
    : `${cleaned.slice(0, 5)}-${cleaned.slice(5)}`;
};
